<template>
    <partner-layout :title="'Timeline - ' + partnerSettings.name">

        <timeline-component :detailed="true" :paginated="true"/>

    </partner-layout>
</template>

<script>
import PartnerLayout from "../../Layouts/PartnerLayout";
import TimelineComponent from "./TimelineComponent";
export default {
    name: "Timeline",
    components: {TimelineComponent, PartnerLayout},
    data(){
        return {
            partnerSettings: this.$page.props.partnerSettings,
        }
    }
}
</script>

<style scoped>

</style>
